import { Amplify, Auth } from 'aws-amplify'
import awsconfig from '../../aws-exports'

Amplify.configure(awsconfig)

export async function signOut() {
  try {
    return await Auth.signOut({ global: true }).then(() => {
      localStorage.clear()
      sessionStorage.clear()
    })
  } catch (error) {
    return error
  }
}
